(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventSchedule', EventSchedule);

    EventSchedule.$inject = ['$resource', 'DateUtils'];

    function EventSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/event-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.finishedAt = DateUtils.convertDateTimeFromServer(data.finishedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
